import React from "react";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";

import "./StatPresence.scss";
import { Locale } from "../../../../../assets/Locale";
import { Timer } from "../../../../../elements/Clocks/Timer/Timer";
import { Block } from "@randajan/jet-react/dom/block";

const presenceItems = [
    { id:"first", labelId:"profileStatsPresenceFirst", field:"firstPresent" },
    { id:"last", labelId:"profileStatsPresenceLast", field:"lastPresent" }
];

export const StatPresence = (props)=>{
    const { stats } = props;
    const say = Locale.use();

    return (
        <Block className="StatPresence" caption={say("profileStatsSectionPresence")}>
            <div className="presenceItems">
                {presenceItems.map(item=>(
                    <div className="presenceItem" key={item.id}>
                        <EventOutlinedIcon className="presenceIcon" />
                        <span className="presenceLabel">{say(item.labelId)}</span>
                        <Timer value={stats?.[item.field]} clockOpt={{ depth:2 }} targetOpt={{}}/>
                    </div>
                ))}
            </div>
        </Block>
    );
};
